import { immerable } from "immer";
import type { SiteScheduleReferenceData } from "@/pages/human-resources/time-management/business/reference/SiteScheduleReferenceData.ts";
import type { DomainScheduleReferenceData } from "@/pages/human-resources/time-management/business/reference/DomainScheduleReferenceData.ts";
import { DailyTagResolver } from "@/pages/human-resources/time-management/business/reference/DailyTagResolver.ts";
import type { ScheduleTemplate } from "@/pages/human-resources/time-management/business/schedule-template/ScheduleTemplate.ts";
import type { DailyTag } from "@/pages/human-resources/time-management/business/daily-tag/DailyTag.ts";
import type { Position } from "@/pages/human-resources/time-management/business/Position.ts";

export class ScheduleReferenceData {
  [immerable] = true;

  public readonly dailyTagsResolver: DailyTagResolver;
  public constructor(
    public readonly domainData: DomainScheduleReferenceData,
    public readonly siteData: SiteScheduleReferenceData,
  ) {
    this.dailyTagsResolver = new DailyTagResolver([
      ...domainData.dailyTags,
      ...siteData.dailyTags,
    ]);
  }

  public siteTimeZone(): string {
    return this.siteData.siteAddress.timeZone;
  }

  public listTemplates(): ScheduleTemplate[] {
    return [
      ...this.domainData.scheduleTemplates,
      ...this.siteData.scheduleTemplates,
    ];
  }

  public listDailyTags(): DailyTag[] {
    return this.dailyTagsResolver.listAll();
  }

  public listEnabledPositions(): Position[] {
    return this.domainData.positions.filter((p) => !p.disabled);
  }
}
